import { Flex } from '@radix-ui/themes';
import { ConnectedCollectionAvenue } from './avenues/ConnectedCollectionAvenue';
import { AVENUE_CONFIGS } from './constants/avenueConfigs';
import { MetricsSection } from './dashboard';

export const HomeUI = () => {
    return (
        <Flex direction={'column'} gap={'8'} mt={'4'} flexGrow={'1'}>
            <MetricsSection />

            {Object.keys(AVENUE_CONFIGS).map((title) => (
                <ConnectedCollectionAvenue
                    key={title}
                    configMap={AVENUE_CONFIGS}
                    title={title as keyof typeof AVENUE_CONFIGS}
                />
            ))}
        </Flex>
    );
};
